var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { color } from 'styled-system';
import { Grid } from '../../common/components/Grid';
import { SliderTitle } from '../../common/components/Text';
import InspirationalTeaserItem from './InspirationalTeaserItem';
var SectionTitle = styled(SliderTitle)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
SectionTitle.defaultProps = __assign(__assign({}, SliderTitle.defaultProps), { px: ['sp_8', null, 'sp_12', 'sp_16'] });
var BaseGrid = styled(Grid)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
BaseGrid.defaultProps = {
    px: [0, '14px', '36px', 6],
};
var TeaserGrid = styled(BaseGrid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), color);
TeaserGrid.defaultProps = {
    bg: ['gray.2', 'white'],
};
var isMultipleOfThree = function (n) { return n % 3 === 0; };
var CommonInspirationalTeaser = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, sectionTitle = _a.title;
    return (React.createElement(React.Fragment, null,
        sectionTitle && (React.createElement(BaseGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
            React.createElement(SectionTitle, { "data-testid": "inspirational-teaser-section-title" }, sectionTitle))),
        React.createElement(TeaserGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width }, items.map(function (item, index) { return (React.createElement(InspirationalTeaserItem, __assign({ key: index }, item, { isEnhanced: isMultipleOfThree(index + 1), index: index }))); }))));
};
CommonInspirationalTeaser.defaultProps = {
    __legacy_shop_reboot_max_width: false,
};
export default CommonInspirationalTeaser;
var templateObject_1, templateObject_2, templateObject_3;
